// extracted by mini-css-extract-plugin
export var actionButton = "_fx-t";
export var buttonContainer = "_fx-0";
export var buttonContainer2 = "_fx-1";
export var buttonSection = "_fx-2";
export var details = "_fx-3";
export var dropdownItem = "_fx-5";
export var dropdownItemsContainer = "_fx-4";
export var fileInput = "_fx-r";
export var headerButton = "_fx-6";
export var icon = "_fx-7";
export var input = "_fx-8";
export var macroListItem = "_fx-9";
export var mainContent = "_fx-a";
export var microText = "_fx-b";
export var modal = "_fx-w";
export var optionsButton = "_fx-c";
export var paperclip = "_fx-s";
export var pillContent = "_fx-d";
export var preview = "_fx-e";
export var preview2 = "_fx-f";
export var quillEditor = "_fx-q";
export var selectedMacro = "_fx-g";
export var sidebar = "_fx-h";
export var sidebarHeader = "_fx-j";
export var sidebarList = "_fx-i";
export var sidebarListItem = "_fx-k";
export var sidebarSearch = "_fx-l";
export var snoozeDurationWrapper = "_fx-v";
export var statusPillContainer = "_fx-m";
export var tagsContainer = "_fx-n";
export var unselectedMacro = "_fx-o";
export var variable = "_fx-u";
export var wrapper = "_fx-p";